import 'promise-polyfill/src/polyfill'
import * as FingerprintJS from '../src'

async function getVisitorData() {
  const fp = await FingerprintJS.load({ debug: false })
  return await fp.get()
}

async function rpaVisitorIDGenerator(): Promise<void> {
  const startTime = Date.now()
  // Check local storage is emapty or not.
  const RPAVisitorID = window.localStorage.getItem('rpa_vid') || 'trashdevice'

  // if RPA Vistior ID is trashdevice
  RPAVisitorID === 'trashdevice' ? window.localStorage.setItem('rpa_vid', 'trashdevice') : null

  try {
    const { visitorId, blendingValue, canvasTextValue } = await getVisitorData()
    const totalTime = Date.now() - startTime

    const isGoogleBot = navigator.userAgent.includes('compatible') || navigator.userAgent.includes('Googlebot')

    if (isGoogleBot) {
      window.localStorage.setItem('rpa_vid', 'GoogleBot')
    }

    if (RPAVisitorID === 'trashdevice' && !isGoogleBot) {
      if (FingerprintJS.isDesktopSafari() || FingerprintJS.isWebKit()) {
        /*
         * Compare Fingerprint ID.
         * On Mac Device Getting Some problem.
         * First time render getting A Key, Second time getting B Key.
         * B Key is the true key.
         * *** Solution:
         * Getting an array to save all generate key in same time.
         * Find out the most value key.
         */
        const key1 = await getVisitorData()
        const key2 = await getVisitorData()
        const key3 = await getVisitorData()
        const key4 = await getVisitorData()
        const key5 = await getVisitorData()

        const KEYARRAY = [
          `${key1.visitorId}@${key1.canvasTextValue}@${key1.blendingValue}`,
          `${key2.visitorId}@${key2.canvasTextValue}@${key2.blendingValue}`,
          `${key3.visitorId}@${key3.canvasTextValue}@${key3.blendingValue}`,
          `${key4.visitorId}@${key4.canvasTextValue}@${key4.blendingValue}`,
          `${key5.visitorId}@${key5.canvasTextValue}@${key5.blendingValue}`,
        ]

        const FILTEREDKEY = KEYARRAY.filter((v, i) => KEYARRAY.indexOf(v) !== i)
        const UNIQUEKEY = new Set(FILTEREDKEY)

        //  Save mostly key into local storage.
        window.localStorage.setItem('rpa_vid', `${Array.from(UNIQUEKEY)[0]}`)
        //  Save process time.
        sessionStorage.setItem('rpa_vid_t', `${totalTime}`)
      } else {
        window.localStorage.setItem('rpa_vid', `${visitorId}@${canvasTextValue}@${blendingValue}`)
      }
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error)
    throw error
  }
}

rpaVisitorIDGenerator()
